// extracted by mini-css-extract-plugin
module.exports = {"cell":"CallListHeadCell_cell__3zS96","container":"CallListHeadCell_container__3PKPd","text":"CallListHeadCell_text__1uhNB"};